import theme from '../themes/default'
import arrowImage from '../../images/select_dropdown_arrow.png'

const screenHeight = window.innerHeight

export default {
  flexCenter: {
    display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
  },
  flex1: {
    flex: '1',
  },
  ml1: {
    'margin-left': '20px',
  },
  disabled: {
    'pointer-events': 'none',
  },
  wrap: {
    position: 'relative',
    'margin-bottom': '170px',
    'z-index': '2',
  },
  'wrap-sticky': {
    'padding-top': '50px',
  },
  'wrap-takeaway': {
    position: 'relative',
  },
  'checkout-header-wrap': {
    position: 'relative',
  },
  'red-bar': {
    'min-height': '26px',
    'background-color': 'rgba(255, 40, 40, 1)',
    color: 'white',
    display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
    padding: '4px',
    'line-height': '1.2rem',
    'flex-direction': 'column',
  },
  'carousel-container': {
    height: `${Math.round(window.innerWidth * 0.4933333) + 125}px`,
  },
  'swiper-container': {
    'margin-bottom': '120px',
  },
  'activity-indicatior-wrap': {
    height: '100%',
    'text-align': 'center',
    'padding-top': '28%',
    '& span': {
      margin: '0 auto',
    },
  },
  premodal: {
    color: 'red',
    '& .am-modal-body': {
      'background-color': '#f5f5f9',
      'padding-bottom': '48px',
      'box-sizing': 'border-box',
    },
  },
  premodalContainer: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
    backgroundColor: '#f5f5f9',
    maxWidth: '1142px',
    margin: '0 auto',
  },
  dateInput: {
    display: 'inline-block',
    'line-height': '40px',
    width: '100%',
    'max-width': '100%',
    color: 'rgb(0, 0, 0)',
    'font-size': '16px',
    '-webkit-appearance': 'none',
    'background-color': 'rgb(255, 255, 255)',
    'background-image': `url(${arrowImage}), linear-gradient(rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)`,
    padding: '0px 1.4em 0px 0.8em',
    margin: '0px',
    'border-width': '1px',
    'border-style': 'solid',
    'border-color': 'rgb(203, 203, 203)',
    'border-image': 'initial',
    'border-radius': '5px',
    'background-repeat': 'no-repeat, repeat',
    'background-position': 'right 0.7em top 50%, 0px 0px',
    outline: 'none',
    'box-sizing': 'border-box',
  },
  timeInput: {
    display: 'inline-block',
    'line-height': '40px',
    width: '100%',
    'max-width': '100%',
    color: 'rgb(0, 0, 0)',
    'font-size': '16px',
    '-webkit-appearance': 'none',
    'background-color': 'rgb(255, 255, 255)',
    'background-image': `url(${arrowImage}), linear-gradient(rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)`,
    padding: '0px 1.4em 0px 0.8em',
    margin: '0px',
    'border-width': '1px',
    'border-style': 'solid',
    'border-color': 'rgb(203, 203, 203)',
    'border-image': 'initial',
    'border-radius': '5px',
    'background-repeat': 'no-repeat, repeat',
    'background-position': 'right 0.7em top 50%, 0px 0px',
    outline: 'none',
    'box-sizing': 'border-box',
  },
  premodalSection: {
    padding: '20px',
    boxShadow: 'rgb(232, 232, 232) 0px -1px 0px 0px inset',
    backgroundColor: '#FFF',
    textAlign: 'left',
  },
  premodalSectionTitle: {
    fontSize: '16px',
    color: '#333',
    fontWeight: 500,
  },
  premodalCover: {
    height: '150px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  },
  premodalDeliveryTypeSelectBox: {
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '137px',
    height: '224px',
    border: '3px solid #95292b',
    padding: '10px',
    borderRadius: '16px',
    color: 'rgb(33, 33, 33)',
    '&$disabled': {
      border: '3px solid #dbdbdb',
    },
  },
  premodalDeliveryTypeSelectBoxDisabledCover: {
    position: 'absolute',
    fontSize: '0.9em',
    backgroundColor: 'rgb(234 234 234 / 0.9)',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    filter: 'grayscale(1)',
    border: '3px solid #000000',
  },
  textCenter: {
    textAlign: 'center',
  },
  premodalDeliveryTypeSelectBoxHeader: {
    'font-size': '1.125rem',
    'line-height': '1.375rem',
    margin: 0,
  },
  premodalDeliveryTypeSelectBoxDesc: {
    'font-size': '0.75rem',
    'line-height': '0.875rem',
  },
  premodalDeliveryTypeButton: {
    display: 'flex',
    '-webkit-box-pack': 'center',
    'justify-content': 'center',
    '-webkit-box-align': 'center',
    'align-items': 'center',
    'text-align': 'center',
    cursor: 'pointer',
    width: 'auto',
    'pointer-events': 'auto',
    color: '#95292b',
    'background-color': 'transparent',
    'box-shadow': 'rgba(0, 0, 0, 0.2) 0px 2px 4px',
    padding: '10px 20px',
    outline: 'none',
    'border-radius': '0px',
    'border-width': '2px',
    'border-style': 'solid',
    'border-color': '#95292b',
    'border-image': 'initial',
  },
  premodalCalendar: {
    margin: '0 auto',
    border: 0,
    '& .react-calendar__navigation button[disabled]': {
      opacity: 0,
      '&.react-calendar__navigation__prev-button': {
        opacity: 1,
        'background-color': 'transparent',
      },
    },
    '& .react-calendar__tile--active, .react-calendar__tile--active:enabled:hover, .react-calendar__tile--active:enabled:focus': {
      'background-color': '#D5AD40',
      color: 'white',
    },
    '& .react-calender__tile': {
    },
    '& .react-calendar__tile:disabled': {
      color: 'rgb(203, 203, 203)',
      'background-color': 'transparent',
      border: 0,
    },
  },
  premodalCalendarTile: {
    color: '#4A4A4A',
  },
  passcodeDialog: {
    display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  passcodeInput: {
    borderRadius: 5,
    margin: 8,
    padding: 8,
    border: '1px solid #d5ad40',
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/Wrap.js